import TruckBaseController from '../common/truck.base.controller'

class truckallController extends TruckBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, Modal, TruckService, $translate, $stateParams, $location) {
    super(Auth, $state, User, TruckService, Modal, $translate, $stateParams, $location)

    this.loading = true
    this.trucks = []
    this.hasAcl = {}
    this.page = 1;
    this.total = 0;
    this.pageLimit = 10;
    this.maxPages = 10
    this.searchText = '';
    this.$location = $location;
    this.branch = User.getUser().branchId;
    this.model.filterByAllBranch = false;
    this.filterByValue = null;
  }

  $onInit() {
    let pageId = this.$stateParams.page
    if (pageId > 0) {
      this.page = pageId
    }
    this.loadData()
  }

  edit(truck) {
    this.$state.go('truck.edit', ({
      id: truck.id
    }))
  }

  delete(truck) {
    if (this.allowOnlyOnce) return;
    this.allowOnlyOnce = true;
    this.Modal.confirm({
      header: this.$translate.instant('common.confirm_delete_title'),
      message: this.$translate.instant('common.confirm_delete_message') + ` <strong>${truck.id}</strong>?`,
      callback: ({
        modal,
        $scope
      }) => {
        $scope.loading = true;
        this.Service.remove(truck.id, this.branch)
          .then((data) => {
            this.allowOnlyOnce = false;
            modal.close();
            this.refresh();
          })
      },
      negative: (({
        modal,
      }) => {
        this.allowOnlyOnce = false;
        modal.close();
      }),
      type: 'danger'
    })
  }

  refresh() {
    this.loadData();
  }

  pageChange() {
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/'+this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData()
  }

  generateSearchObj() {
    return {
      queryText: '%' + this.searchText + '%',
      isQuery: false,
      branch : this.branch,
      filterByAllBranch: this.model.filterByAllBranch
    }
  }

  search() {
    this.page = 1;
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/'+this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData()
  }

  loadData() {
    const searchObj = this.generateSearchObj();
    
    this.loading = true
    this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit)
      .then((data) => {
        this.total = data.total
        this.loading = false
        this.trucks = data.results
      })
      .catch((err) => {
        this.loading = false;
        this.error = err.message;
        this.Modal.errorModal(err.data.message);
      })
  }

  toggleExpand(truck) {
    truck.expand = !truck.expand;
  }

  filterByBranch(value) {
    this.page = 1;
    this.filterByValue = this.filterByValue === value ? undefined : value;
    this.model.filterByAllBranch = this.filterByValue ? true : false;
    this.loadData();
  }
}

export default truckallController;


// WEBPACK FOOTER //
// ./client/app/components/truck/all/truck.all.controller.js